// extracted by mini-css-extract-plugin
module.exports = {"chart":"graph_chart__1BGsp","nodata":"graph_nodata__1pZOm"};